import { useEffect, useRef, useState } from "react";
import { CustomLoader } from "../../../shared/components/custom-loader/custom-loader";
import { FormInput } from "../../../shared/components/form-component/form-input";
import { CUSTOM_VALIDATION } from "../../../shared/validation/validation";
import { SERVICES } from "../../../core/services/services";
import { HELPER } from "../../../shared/helper/helper";
import { Toast } from "primereact/toast";
import { FormDropdown } from "../../../shared/components/form-component/form-dropdown";
import { CustomToast } from "../../../shared/components/alert/custom-toast";
import { Optional } from "../../../shared/components/optional/optional";
import { BACKOFFICE_API } from "../../../core/apis/backoffice-apis";
import { SuccessMessage } from "../../../shared/components/success-message/success-message";
// import { useVerificationLimitsValidityResponse } from "../../../core/custom-hooks/use-verification-limits-validity-response";

export function VerificationLimitUpdateForm(props) {
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [verificationLimit, setVerificationLimit] = useState({
    name: null,
    minimumAmount: "",
    maxAmount: "",
    status: null,
  });
  const [formErrors, setFormErrors] = useState({
    minimumAmount: null,
    maxAmount: null,
    status: null,
  });
  const limitStatuses = [
    { label: "ACTIVE", value: "true" },
    { label: "INACTIVE", value: "false" },
  ];
  const [isValidForm, setIsValidForm] = useState(true);
  const [isInfiniteMaxAmount, setIsInfiniteMaxAmount] = useState(false);

  useEffect(() => {
    function validateForm() {
      const { minimumAmount, maxAmount, status } = verificationLimit;
      const miniminumValidForm = {
        minimumAmount,
        maxAmount,
        status,
      };
      const hasValidErrors = CUSTOM_VALIDATION.VALID_OBJ_ANY(formErrors);
      const isValidForm = CUSTOM_VALIDATION.IS_VALID_FORM(miniminumValidForm);
      setIsValidForm(isValidForm && hasValidErrors === false);
    }
    validateForm();
  }, [formErrors, verificationLimit]);

  useEffect(() => {
    const verificationLimit = props.verificationLimit;
    const { minimumAmount, maxAmount, isActive } = verificationLimit;
    let validMaxAmount = null;
    if (maxAmount === -1) {
      validMaxAmount = "Infinity";
      setIsInfiniteMaxAmount(true);
    } else if (maxAmount === 0) {
      validMaxAmount = 0;
    } else {
      validMaxAmount = HELPER.TO_MAJOR_AMOUNT(maxAmount);
    }
    setVerificationLimit({
      ...verificationLimit,
      minimumAmount:
        minimumAmount === 0 ? 0 : HELPER.TO_MAJOR_AMOUNT(minimumAmount),
      maxAmount: validMaxAmount,
      status: String(isActive),
    });
  }, [props.verificationLimit]);

  function submit() {
    setLoading(true);
    let { allowedVerificationChannels, verificationType, ...payload } =
      verificationLimit;
    const maximumAmount = payload?.maxAmount;
    payload = {
      status: payload.status === "true" ? true : false,
      minAmount: HELPER.TO_MINOR_AMOUNT(payload?.minimumAmount),
      maxAmount: HELPER.TO_MINOR_AMOUNT(payload?.maxAmount),
    };
    if (isInfiniteMaxAmount || maximumAmount === "-1") {
      payload = {
        ...payload,
        maxAmount: -1,
      };
    }
    SERVICES.MAKE_PUT_REQUEST(
      `${BACKOFFICE_API.VERIFICATION_LIMITS}/${verificationType}`,
      payload
    )
      .then(() => {
        setSuccessMessage("Authentication limit successfully updated.");
        setLoading(false);
      })
      .catch((error) => {
        setErrorMessage(HELPER.PROCESS_ERROR(error));
        setLoading(false);
      });
  }

  function validateForm(e, name, type, field, required) {
    let value = e?.target?.value;
    const isEmpty = CUSTOM_VALIDATION.IS_EMPTY(value);
    const isValidInput = !isEmpty
      ? CUSTOM_VALIDATION.BASIC_VALIDATION(value, type)
      : false;
    if (isValidInput) {
      setVerificationLimit({ ...verificationLimit, [name]: value });
      setFormErrors({ ...formErrors, [name]: null });
    } else {
      let errorMessage = required && isEmpty ? `${field} is required` : null;
      if (!isValidInput) {
        errorMessage = `${field} is invalid`;
      }
      if (isEmpty && !required) {
        setVerificationLimit({ ...verificationLimit, [name]: null });
        setFormErrors({ ...formErrors, [name]: null });
      } else {
        setFormErrors({
          ...formErrors,
          [name]: errorMessage,
        });
      }
    }
  }

  function handleInfiniteMaxAmountChange(e) {
    const isInfinite = e?.target?.checked;
    const maxAmountField = document.getElementById("maxAmount");

    setIsInfiniteMaxAmount(isInfinite);
    if (isInfinite) {
      maxAmountField.value = "Infinity";
      setVerificationLimit({
        ...verificationLimit,
        maxAmount: "Infinity",
      });
      setFormErrors({
        ...formErrors,
        maxAmount: null,
      });
    } else {
      maxAmountField.value = "";
      setVerificationLimit({
        ...verificationLimit,
        maxAmount: "",
      });
    }
  }

  function cancelModal() {
    props.closeModal();
  }

  function validateDropdown(e, name) {
    const value = e.target.value;
    if (value) {
      setFormErrors({ ...formErrors, [name]: "" });
      setVerificationLimit({ ...verificationLimit, [name]: value });
    }
  }

  const cancelButton = () => {
    if (!loading) {
      return (
        <button onClick={cancelModal} className="secondary-button">
          Cancel
        </button>
      );
    } else {
      return <div />;
    }
  };

  const submitButton = () => {
    if (!loading) {
      return (
        <button
          onClick={submit}
          className="primary-button"
          disabled={!isValidForm}
        >
          Submit
        </button>
      );
    } else {
      return (
        <div className="pull-up-element-2 p-mt-4">
          <CustomLoader loadingText="Submitting..." />
        </div>
      );
    }
  };

  const viewAlert = () => {
    if (errorMessage) {
      return (
        <div>
          <CustomToast title="Error" description={errorMessage} type="error" />
        </div>
      );
    }
  };

  const renderForm = () => {
    return (
      <div>
        <div className="custom-modal-title p-text-left">
          Update Authentication Limit
        </div>
        <div className="custom-dialog-subtitle-container p-mb-5"></div>
        <div className="p-grid">
          <div className="p-col-12">
            <FormInput
              value={verificationLimit["name"]}
              required={true}
              field="name"
              type="INPUT"
              fn={validateForm}
              disabled={true}
              placeholder="Name"
            />
          </div>
          {/* <div className="p-col-12">
            <FormInput
              value={verificationLimit["allowedVerificationChannels"]}
              required={true}
              field="allowedVerificationChannels"
              type="INPUT"
              fn={validateForm}
              disabled={true}
              placeholder="Allowed Authentication Channels"
            />
          </div> */}
          <div className="p-col-12 p-text-left">
            <FormInput
              value={verificationLimit["minimumAmount"]}
              required={true}
              field="minimumAmount"
              type="NUMBER"
              error={formErrors["minimumAmount"]}
              fn={validateForm}
              placeholder="Minimum Amount (₦)"
            />
          </div>

          <div className="p-col-12">
            <label
              style={{ display: "flex", cursor: "pointer" }}
              className="p-mt-3 flex default"
            >
              <input
                type="checkbox"
                className="infinite-max-amount"
                checked={isInfiniteMaxAmount}
                onChange={handleInfiniteMaxAmountChange}
              />
              <small className="p-text-left p-ml-2">Set to Infinity</small>
            </label>
          </div>
          <div className="p-col-12 p-text-left">
            <FormInput
              value={verificationLimit["maxAmount"]}
              required={true}
              field="maxAmount"
              type="NUMBER"
              error={formErrors["maxAmount"]}
              fn={validateForm}
              placeholder="Maximum Amount (₦)"
              disabled={isInfiniteMaxAmount}
            />
          </div>
          <div className="p-col-12">
            <FormDropdown
              required={true}
              field="status"
              error={formErrors["status"]}
              disabled={loading}
              value={verificationLimit["status"]}
              fn={validateDropdown}
              options={limitStatuses}
              placeholder="Status"
            />
          </div>
          <div className="p-col-12">{viewAlert()}</div>
          <div className="p-col-12">
            <div className="">
              <div className="p-grid">
                <div className={loading ? "p-col-12" : "p-col-6"}>
                  {cancelButton()}
                </div>
                <div className={loading ? "p-col-12" : "p-col-6"}>
                  {submitButton()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div>
        <Toast ref={toast} />
      </div>
      <Optional show={!successMessage}>
        <div className="p-pb-2">{renderForm()}</div>
      </Optional>
      <Optional show={successMessage}>
        <SuccessMessage
          message={successMessage}
          closeModal={props.closeModal}
        />
      </Optional>
    </div>
  );
}
